import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { setIsAuthenticated } from 'app/domain/authentication/slice';
import selectAuthenticationState from 'app/domain/authentication/slice/selectors';
import TokenService from 'app/domain/authentication/tokenService';
import { isObjectFullyFilled } from 'utils/utils';

const useCheckAuthentication = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { isAuthenticated } = useSelector(selectAuthenticationState);
  useEffect(() => {
    // centralized auth
    const userAuth = TokenService.getUserAuthLS();
    const { user_id, ...restUserAuth } = userAuth;
    if (userAuth && !isObjectFullyFilled(restUserAuth) && isAuthenticated) {
      dispatch(setIsAuthenticated(false));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, location.pathname]);
};

export default useCheckAuthentication;
